import React from "react";
import {
  Phone,
  MessageCircle,
  MapPin,
  Circle,
  Star,
  ArrowLeft,
  ShieldCheck,
} from "lucide-react";

const TrackingOrderLeftPanel = ({
  onBack,

  acceptedDriver,
  selectedVehicle,
  vehicleMeta,
  vehicleIcon,

  registrationNumber,
  randomOtp,

  routeDistanceText,
  routeDurationText,

  formData,
  orderId,

  selectedExtra,
  totalPrice,

  setShowCancelModal,
}) => {
  return (
    <div className="order-2 flex h-full min-h-0 flex-col overflow-y-auto bg-white px-5 py-5 sm:px-7 md:px-6 lg:order-1 lg:px-6 lg:py-5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      <div className="w-full">
        {/* BACK */}
        <button
          type="button"
          onClick={onBack}
          className="mb-3 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
        >
          <ArrowLeft size={17} />
          Back
        </button>

        {/* STATUS */}
        <div className="mb-3 flex flex-col gap-3 rounded-2xl border border-green-100 bg-green-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5">
          <div className="min-w-0 flex-1">
            <h3 className="text-[17px] font-bold text-green-700 sm:text-[18px]">
              Driver is on the Way
            </h3>

            <p className="mt-1 text-sm leading-5 text-slate-600">
              {acceptedDriver.name} is heading to pickup location{" "}
              {acceptedDriver.distance} away
              {routeDistanceText && (
                <span className="block text-xs text-slate-500">
                  Trip route: {routeDistanceText}
                  {routeDurationText ? ` • ${routeDurationText}` : ""}
                </span>
              )}
            </p>
          </div>

          <button
            type="button"
            className="w-fit shrink-0 rounded-xl bg-[#f97316] px-4 py-2 text-center text-sm font-bold text-white transition hover:bg-[#ea580c] sm:min-w-[72px]"
          >
            {acceptedDriver.eta}
          </button>
        </div>

        {/* DRIVER */}
        <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
          <div className="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex min-w-0 items-start gap-3">
              <div className="relative shrink-0">
              <img
  src={acceptedDriver.image}
  alt="driver"
  className="h-12 w-12 sm:h-14 sm:w-14 rounded-full object-cover"
/>

                <span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-green-500 ring-2 ring-white">
                  <ShieldCheck size={14} className="text-white" />
                </span>
              </div>

              <div className="min-w-0 flex-1">
                <h4 className="inline-block max-w-full truncate rounded-full bg-orange-100 px-3 py-1 text-[14px] font-bold text-slate-800 sm:text-[15px]">
                  {acceptedDriver.name}
                </h4>

                <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-500 sm:text-sm">
                  <span>{selectedVehicle}</span>
                  <span>|</span>
                  <span>{registrationNumber}</span>
                </div>

                <div className="mt-2 flex flex-wrap items-center gap-1 text-xs text-slate-500 sm:text-sm">
                  <Star
                    size={14}
                    className="fill-yellow-400 text-yellow-400"
                  />
                  <span>{acceptedDriver.rating}</span>
                  <span>•</span>
                  <span>{acceptedDriver.distance}</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">
              <button
                type="button"
                className="flex h-10 items-center justify-center gap-2 rounded-xl bg-green-100 px-3 text-sm font-semibold text-green-700 sm:h-9 sm:w-9 sm:px-0"
              >
                <Phone size={18} />
                <span className="sm:hidden">Call</span>
              </button>

              <button
                type="button"
                className="flex h-10 items-center justify-center gap-2 rounded-xl bg-blue-100 px-3 text-sm font-semibold text-blue-700 sm:h-9 sm:w-9 sm:px-0"
              >
                <MessageCircle size={18} />
                <span className="sm:hidden">Chat</span>
              </button>
            </div>
          </div>

          <div className="flex flex-col gap-3 border-t bg-slate-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-2 sm:py-2">
            <p className="text-sm font-medium text-slate-700">
              Start your Order with PIN
            </p>

          <div className="flex flex-wrap justify-start gap-2">
  {randomOtp.map((num, index) => (
    <span
      key={index}
      className="flex h-8 w-8 items-center justify-center rounded-lg border bg-white text-sm font-bold text-slate-700 sm:h-7 sm:w-7"
    >
      {num}
    </span>
  ))}
</div>
          </div>
        </div>

        {/* DELIVERY INFO */}
        <div className="mb-3 rounded-2xl border border-slate-200 bg-white">
          <div className="border-b px-4 py-2">
            <h3 className="text-[18px] font-bold text-slate-800">
              Delivery Info
            </h3>
          </div>

        <div className="px-4 py-3">
  <div className="flex items-stretch gap-3">
    {/* Left Side */}
    <div className="flex w-5 flex-col items-center">
      <MapPin
        size={15}
        className="mt-1 shrink-0 text-blue-500"
        fill="currentColor"
      />

      <div className="my-1 flex-1 border-l-2 border-dashed border-slate-300"></div>

      <MapPin
        size={15}
        className="mb-1 shrink-0 text-green-600"
        fill="currentColor"
      />
    </div>

    {/* Addresses */}
    <div className="min-w-0 flex-1">
      <div className="pb-5">
        <p className="break-words text-sm leading-6 text-slate-500">
          {formData?.pickupAddress || "Pickup address not added"}
        </p>
      </div>

      <div>
        <p className="break-words text-sm leading-6 text-slate-500">
          {formData?.dropAddress || "Drop address not added"}
        </p>
      </div>
    </div>
  </div>
</div>
        </div>

        {/* ADDITIONAL INFO */}
        <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
          <h3 className="border-b px-4 py-2 text-[18px] font-bold text-slate-800">
            Additional Info
          </h3>

          <div className="space-y-2 px-4 py-3 text-sm">
            <div className="flex justify-between gap-4">
              <span className="font-semibold text-slate-500">Order ID</span>
              <span className="text-right text-slate-500">{orderId}</span>
            </div>

            <div className="flex justify-between gap-4">
              <span className="font-semibold text-slate-500">
                Receiver Name
              </span>
              <span className="text-right text-slate-500">
                {formData?.receiverName || "-"}
              </span>
            </div>

            <div className="flex justify-between gap-4">
              <span className="font-semibold text-slate-500">
                Receiver Number
              </span>
              <span className="text-right text-slate-500">
                {formData?.receiverMobile || "-"}
              </span>
            </div>

            {formData?.deliveryType === "schedule" && (
              <div className="flex justify-between gap-4">
                <span className="font-semibold text-slate-500">Schedule</span>
                <span className="text-right text-slate-500">
                  {formData?.scheduleDate || "-"} {formData?.scheduleTime || ""}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* VEHICLE PRICE */}
       <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-300 bg-orange-50">
              <img
                src={vehicleIcon}
                alt={selectedVehicle}
                className="h-[45px] w-[55px] object-contain"
              />
            </div>

            <div>
              <h4 className="font-bold text-slate-800">{selectedVehicle}</h4>
              <p className="text-sm text-slate-500">
                Upto {vehicleMeta?.weight || 0} kg
              </p>

              {selectedExtra > 0 && (
                <p className="text-xs font-semibold text-green-600">
                  Extra fare added: ₹{selectedExtra}
                </p>
              )}
            </div>
          </div>

          <div className="text-right">
            <p className="text-sm text-slate-500">Total Price</p>
            <h3 className="text-[18px] font-bold text-slate-900">
              ₹{totalPrice}
            </h3>
          </div>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="mt-auto grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => setShowCancelModal(true)}
          className="rounded-2xl border border-red-100 bg-red-50 py-3 font-bold text-red-600 transition hover:bg-red-100"
        >
          Cancel Order
        </button>

        <button
          type="button"
          onClick={() => {}}
          className="w-full rounded-2xl bg-[#2563eb] py-3 font-semibold text-white transition hover:opacity-90"
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default TrackingOrderLeftPanel;